module.exports = __webpack_public_path__ + "static/media/jeff_piejak.5fd335c4.JPG";